import { useState, useCallback, useEffect } from "react";
import { useSelections } from "../context/Selections";

export const useInsightsData = (app) => {
  const selection = useSelections();
  const [data, setData] = useState({
    comparativeCurrentPoints: null,
    comparativePercentage: null,
    comparativePreviousPoints: null,
    monthlyCurrentPoints: null,
    monthlyPercentage: null,
    monthlyPreviousPoints: null,
    almostThere: null,
    opportunities: null,
  });

  const [percentages, setPercentages] = useState({
    comparative: 0,
    monthly: 0,
    almostThere: 0,
    opportunities: 0,
  });

  const getAlmostThereOpportunities = useCallback(
    async (objectId, name) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;

          setData((prev) => ({
            ...prev,
            [name]: value,
          }));
        } catch (error) {
          console.error(`Erro ao buscar ${name}:`, error);
        }
      }
    },
    [app]
  );

  const getComparative = useCallback(
    async (objectId, position, type = "annual") => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;

          const fields = {
            annual: {
              1: "comparativeCurrentPoints",
              2: "comparativePercentage",
              3: "comparativePreviousPoints",
            },
            monthly: {
              1: "monthlyCurrentPoints",
              2: "monthlyPercentage",
              3: "monthlyPreviousPoints",
            },
          };

          const field = fields[type]?.[position];

          if (field) {
            setData((prev) => ({
              ...prev,
              [field]: value,
            }));
          }
        } catch (error) {
          console.error(
            `Erro ao buscar comparativo ${type} ${position}:`,
            error
          );
        }
      }
    },
    [app]
  );

  useEffect(() => {
    getComparative("PJxNSh", 1, "annual");
    getComparative("FvSbrC", 2, "annual");
    getComparative("hvapG", 3, "annual");
    getComparative("bBWATWk", 1, "monthly");
    getComparative("SstcRs", 2, "monthly");
    getComparative("zAjMenL", 3, "monthly");
    getAlmostThereOpportunities("MuDsJB", "almostThere");
    getAlmostThereOpportunities("pJMba", "opportunities");
  }, [app, getAlmostThereOpportunities, getComparative, selection]);

  useEffect(() => {
    const calculatePercentage = (value) => {
      const num = value ? parseFloat(value) : 0;
      return num > 100 ? 100 : num;
    };

    setPercentages({
      comparative: calculatePercentage(data.comparativePercentage),
      monthly: calculatePercentage(data.monthlyPercentage),
      almostThere: calculatePercentage(data.almostThere),
      opportunities: calculatePercentage(data.opportunities),
    });
  }, [data]);

  return { data, percentages };
};
